// 注意，这个hook只是处理了逻辑（输出isFixed)，样式还是需要自行处理
import { RefObject, useEffect, useState, useContext} from 'react';
import { getElementTop } from '../../utils/dom';
import { PageContext } from '../ComponentNavigatorV2/PageContext';

interface IUseScrollFixElement {
  disable?: boolean; // 是否禁用该功能
}

let elementTop = 0;
export default (props: IUseScrollFixElement) => {
  const { disable } = props;
  const context = useContext(PageContext);
  const [wrapper, setWrapper] = useState(null as RefObject<HTMLElement> | null);
  const [isFixed, setIsFixed] = useState(false);

  useEffect(()=>{
    const onScrollEvent = (e:any)=>{
      if(wrapper && wrapper.current) {
        let rect = wrapper.current.getClientRects();
        if(rect && rect.length) {
          const {y, top} = rect[0] as any;
          if(y < 0) {
            setIsFixed(true);
          }
          else if(y >= 0) {
            setIsFixed(false);
          }
        }
      }
    };

    if(wrapper && wrapper.current && !disable) {
      window.addEventListener(`page-scroll-move-${context.cid}`, onScrollEvent);
    }

    return ()=>{
      window.removeEventListener(`page-scroll-move-${context.cid}`, onScrollEvent);
    };
  }, [wrapper, isFixed]);

  return {
    isFixed,
    setWrapper
  };
};
